




























































































import Vue from "vue";
import { mapState } from "vuex";
import { Customer } from "../../entities/customer";

export default Vue.extend({
  components: {},
  data() {
    return {
      showError: false,
      textError: "",
      name: "",
      prefix: "",
      prefixes: [] as Array<string>,
      id: 0,
      validForm: false,
      saving: false,
      rules: [
        (v: string) => v.length <= 25 || "Maximo 8 digitos",
        (v: string) => /^\d+$/.test(v) || "Solo numeros",
      ],
    };
  },
  props: {
    customerId: {
      type: Number,
    },
  },
  created() {
    if (this.customer) {
      this.name = this.customer.name;
      this.prefixes = this.customer.prefixes ?? [];
      this.id = this.customer.id;
    }
  },
  computed: {
    ...mapState("customers", { allCustomers: "customers" }),

    allowSave(): boolean {
      if (
        !this.saving &&
        this.name &&
        this.prefixes &&
        this.prefixes.length > 0
      ) {
        return true;
      }
      return false;
    },
    customer(): Customer | undefined {
      const u = this.allCustomers?.find(
        (u: Customer) => u.id == this.customerId
      );
      return u;
    },
    title(): string {
      if (this.customer) {
        return `Editando cliente: ${this.customer.name}`;
      }
      return "Nuevo cliente";
    },
  },
  methods: {
    async save() {
      this.saving = true;
      let saveUser = {
        name: this.name,
        prefixes: this.prefixes,
      };
      try {
        if (this.customerId) {
          saveUser = Object.assign({}, saveUser, {
            id: Number(this.customerId),
          });
          await this.$store.dispatch("customers/updateCustomer", saveUser);
        } else {
          await this.$store.dispatch("customers/createCustomer", saveUser);
        }
        this.$router.push("/customers");
        this.saving = false;
      } catch (err) {
        this.saving = false;
      }
    },
    removePrefix(prefix: string): void {
      this.prefixes = this.prefixes.filter(function (item) {
        return item != prefix;
      });
    },
    addPrefix(): void {
      if (!this.prefixes.some((prefix) => prefix === this.prefix)) {
        if (this.prefix.length <= 8) {
          this.prefixes.push(this.prefix);
          this.prefix = "";
        } else {
          this.showMessageError("El prefijo solo puede tener 8 caracteres!");
        }
      } else {
        this.showMessageError("El prefijo ya existe!");
      }
    },
    showMessageError(message: string) {
      this.textError = message;
      this.showError = true;
    },
  },
});
